import React, { useState, useEffect, Suspense } from 'react';

const DemoController = React.lazy(() => import('../demo/DemoController'));

const DEMO_STATE_KEY = 'demo_controller_state';

const DemoLauncher: React.FC = () => {
  const [active, setActive] = useState(() => {
    try {
      const raw = sessionStorage.getItem(DEMO_STATE_KEY);
      if (raw) {
        const state = JSON.parse(raw);
        return state?.active === true;
      }
    } catch { /* ignore */ }
    return false;
  });

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Ctrl+Alt+D — chosen to avoid conflicting with browser shortcuts
      if (e.ctrlKey && e.altKey && e.key === 'd') {
        e.preventDefault();
        setActive(true);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  if (!active) return null;

  return (
    <Suspense fallback={null}>
      <DemoController onComplete={() => setActive(false)} />
    </Suspense>
  );
};

export default DemoLauncher;
